import { FC } from 'react';
import { Navigate } from 'react-router-dom';
/* istanbul ignore next */
const RedirectToSwagger: FC = () => {
  const accessToken = localStorage.getItem('accessToken');
  const allowedRedirectUrls: (string | undefined)[] = [
    'http://localhost:9011/operations-ui',
    'https://phapi-dev.yum.com/operations-ui',
    'https://phapi-qa.yum.com/operations-ui',
  ];
  if (!allowedRedirectUrls.includes(process.env.REACT_APP_OPSUI_API_URL) || process.env.REACT_APP_ENV === 'prod') {
    return <Navigate to='/tables' />;
  }
  if (accessToken) {
    window.location.replace(`${process.env.REACT_APP_OPSUI_API_URL}/swagger-ui/index.html?token=${accessToken}`);
  }
  return <Navigate to='/login' />;
};

export default RedirectToSwagger;
